module.exports = __webpack_public_path__ + "img/img21.a6c3dc36.png";